// Imports:
import Request from 'tdmnco-request'

// Context:
Request.get({
  url: 'https://api.ale.farm/investor/company-announcements/' + window.location.pathname.substring(34)
}).then((response) => {
  if (response.data && response.data.length > 0) {
    const data = JSON.parse(response.data)
    const locale = window.location.pathname.split('/')[3]
    const title = data.title

    document.title = title

    document.getElementById('featured-news-signature-' + locale + '-kasper-tidemann').style = 'display: block;'
    document.getElementById('featured-news-signature-' + locale + '-kresten-thorndahl').style = 'display: block;'
    document.getElementById('featured-news-company-announcement-' + locale).style = 'display: block;'
    document.getElementById('featured-news-title').textContent = title
    document.getElementById('featured-news-content').insertAdjacentHTML('beforeend', data.content)

    const $tables = document.querySelectorAll('table')

    for (let $table of $tables) {
      const $wrapper = document.createElement('div')
      
      $wrapper.classList.add('table')

      $table.parentNode.insertBefore($wrapper, $table)

      $wrapper.appendChild($table)
    }

    const didChangeCEO = (new Date(data.date)) > (new Date('2024-10-31T23:59:59'));

    if (didChangeCEO) {
      document.getElementById('featured-news-author-kresten-thorndahl').style = 'display: flex;'
      document.getElementById('featured-news-author-signature-kresten-thorndahl').style = 'display: block;'
    } else {
      document.getElementById('featured-news-author-kasper-tidemann').style = 'display: flex;'
      document.getElementById('featured-news-author-signature-kasper-tidemann').style = 'display: block;'
    }
  }
})